const FactoringCompanyRoute = {
  path: '/FactoringCompany',
  load: () => import('./FactoringCompany'),
  protected: true,
};

const FactoringCompanyDetailsRoute = {
  path: '/FactoringCompany/details/:id',
  load: () => import('./factoringCompanyDetails'),
  protected: true,
};

const FactoringCompanyDetailsCreationRoute = {
  path: '/FactoringCompany/details/',
  load: () => import('./factoringCompanyDetails'),
  protected: true,
};

export {
  FactoringCompanyDetailsCreationRoute,
  FactoringCompanyDetailsRoute,
  FactoringCompanyRoute,
};
